// extracted by mini-css-extract-plugin
export var button = "_d3-4";
export var hasDarkBackground = "_d3-7";
export var hasLightBackground = "_d3-6";
export var iconWrapper = "_d3-0";
export var large = "_d3-2";
export var medium = "_d3-1";
export var small = "_d3-5";
export var xsmall = "_d3-3";